import  { useState } from "react";
import { Route, Routes } from "react-router-dom";
import VirementsByDirectionPage from "../../../../pages/module-pages/administration/virements-bacaires/VirementsByDirectionPage";

export default function VirementBancaireNav() {
  const [currentDirection, setCurrentDirection] = useState("");

  const onDirectionChange = (direction: string) => {
    setCurrentDirection(direction);
  };

  return (
    <Routes>
      <Route
        path="/canada-cmr"
        element={
          <VirementsByDirectionPage
            currentDirection={currentDirection || "canada-cmr-banque"}
            onDirectionChange={onDirectionChange}
          />
        }
      />
    </Routes>
  );
}
